import axios from 'axios';

const crmBaseClient = axios.create({ baseURL: '/api/', validateStatus: status => status < 500 });

crmBaseClient.interceptors.request.use(request => {
  const token = localStorage.getItem('jwtToken');
  const locale = localStorage.getItem('locale');

  if (locale) {
    request.headers.locale = locale;
  }
  if (token) {
    request.headers.Authorization = `JWT ${token}`;
  }
  return request;
});

export default crmBaseClient;
